import React, { useEffect, useState } from "react";
import SummaryApi from "../../common";

const ContactList = () => {
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  // Fetch contact data
  useEffect(() => {
    const fetchContacts = async () => {
      try {
        const response = await fetch(SummaryApi.getContact.url);
        if (!response.ok) {
          throw new Error("Failed to fetch contacts");
        }
        const data = await response.json();
        setContacts(data);
      } catch (err) {
        console.error(err);
        setError("Something went wrong while fetching contacts.");
      } finally {
        setLoading(false);
      }
    };

    fetchContacts();
  }, []);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-60">
        <p className="text-gray-600 text-lg font-semibold">Loading contacts...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex justify-center items-center h-60">
        <p className="text-red-500 text-lg font-semibold">{error}</p>
      </div>
    );
  }

  return (
    <section className="py-10 px-6 bg-gray-100 min-h-screen">
      <h2 className="text-3xl font-bold text-center mb-8">Contact Submissions</h2>

      {contacts.length === 0 ? (
        <p className="text-center text-gray-600 text-lg">
          No contacts available yet.
        </p>
      ) : (
        <div className="grid gap-6 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
          {contacts.map((contact) => (
            <div
              key={contact._id}
              className="bg-white shadow-md hover:shadow-lg rounded-xl p-6 transition duration-300"
            >
              <h3 className="text-xl font-semibold text-orange-600 mb-2">
                {contact.name}
              </h3>
              <p className="text-gray-700 mb-1">
                <strong>Email:</strong> {contact.email}
              </p>
              <p className="text-gray-700 mb-1">
                <strong>Phone:</strong> {contact.phone}
              </p>
              <p className="text-gray-700 mt-2 italic">"{contact.message}"</p>
              <p className="text-gray-400 text-sm mt-3">
                {new Date(contact.createdAt).toLocaleDateString("en-GB")}{" "}
                {new Date(contact.createdAt).toLocaleTimeString("en-US", {
                    hour: "2-digit",
                    minute: "2-digit",
                    hour12: true,
                })}
                </p>

            </div>
          ))}
        </div>
      )}
    </section>
  );
};

export default ContactList;
